export var ConditionOperators = /*#__PURE__*/ function(ConditionOperators) {
    ConditionOperators["equal"] = "equal";
    ConditionOperators["notEqual"] = "notEqual";
    ConditionOperators["notEmpty"] = "notEmpty";
    ConditionOperators["empty"] = "empty";
    ConditionOperators["contains"] = "contains";
    ConditionOperators["notContains"] = "notContains";
    ConditionOperators["greaterThanOrEqual"] = "greaterThanOrEqual";
    ConditionOperators["greaterThan"] = "greaterThan";
    ConditionOperators["afterOrEqual"] = "afterOrEqual";
    ConditionOperators["after"] = "after";
    ConditionOperators["lessThanOrEqual"] = "lessThanOrEqual";
    ConditionOperators["lessThan"] = "lessThan";
    ConditionOperators["beforeOrEqual"] = "beforeOrEqual";
    ConditionOperators["before"] = "before";
    ConditionOperators["between"] = "between";
    ConditionOperators["any"] = "any";
    ConditionOperators["arrayEqual"] = "arrayEqual";
    ConditionOperators["arrayNotEqual"] = "arrayNotEqual";
    ConditionOperators["checked"] = "checked";
    ConditionOperators["notChecked"] = "notChecked";
    ConditionOperators["in"] = "in";
    ConditionOperators["notIn"] = "notIn";
    ConditionOperators["isDateNewerThan"] = "isDateNewerThan";
    ConditionOperators["isDateOlderThan"] = "isDateOlderThan";
    ConditionOperators["isDateNewerThanOrEqual"] = "isDateNewerThanOrEqual";
    ConditionOperators["isDateOlderThanOrEqual"] = "isDateOlderThanOrEqual";
    return ConditionOperators;
}({});

//# sourceMappingURL=condition-operators.js.map